import { LabelsPayload } from "../../components/Labels/types";

const replaceSingleEntry = (labels: LabelsPayload, str?: string): string => {
	const configStr = `Single ${labels.entry.singular}`;
	const replacedStr = str
		? str.replaceAll("Single Entry", configStr)
		: configStr;

	return replacedStr;
};

/** zero-width chars used in campaign batch labels from the API */
// \u200B - zero-width space
// \u200C - zero-width non-joiner
// \u200D - zero-width joiner
// \uFEFF - BOM / zero-width no-break space

const stripInvisibleChars = (label: string) =>
	label.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();

export const isSingleOrCampaignBatchLabel = (
	label: string,
	entrySingular?: string,
): boolean => {
	const normalized = stripInvisibleChars(label);
	if (
		normalized === "Single Entry" ||
		normalized === "Campaign" ||
		normalized === "Campaign Entry"
	) {
		return true;
	}
	if (entrySingular && normalized === `Single ${entrySingular}`) {
		return true;
	}
	return false;
};

/** Hide trailing Single/Campaign batch label when FF is on. */
export const filterBatchLabels = (
	batchLabels: string[],
	hideSingleCampaignLabel: boolean,
	entrySingular?: string,
): string[] => {
	if (!hideSingleCampaignLabel) {
		return batchLabels;
	}
	return batchLabels.filter(
		(label) => !isSingleOrCampaignBatchLabel(label, entrySingular),
	);
};

export default replaceSingleEntry;
